export default __webpack_public_path__ + "static/media/apple_firefox.1cc59d26.svg";